/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseActions from "features/library/actions/library-item-actions/BaseActions";
import { ColorCircle } from "features/library/components/CustomLibrary/ColorCircle";
import { getCustomLibraryLinkedRecordsFn, upsertValueLibrary } from "features/library/reducer/LibraryActions";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAllCustomLibraryItems } from "redux/memoizedSelectors";
import { Spinner } from "shared/components/spinners/Spinner";
import { SideModal } from "shared/cx-components/cx-components.style";
import Header from "shared/cx-components/header";
import HeaderTitle from "shared/cx-components/header-title";
import Relations from "shared/cx-components/relations/relations";
import { TypesTabs } from "shared/cx-components/relations/tabs-data";
import { ItemProvider, useItem } from "shared/dynamic-imports";
import { useNavigationListData } from "shared/hooks";
import { encode } from "utils/helpers";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	customItemsIds?: string[];
	libraryId: string;
	itemId: string;
	stageId?: string;
};

export default function EditCustomLibrary(props: Props): JSX.Element {
	const { isOpen, onClose, libraryId, itemId } = props;
	const currentItem = useSelector((state: any) => state?.libraries?.customLibraries.find((cl: any) => cl.id === libraryId)?.values?.find((value: any) => value?.id === itemId) || []);

	const handleUpdateLibraryItem = ({ item, modifiedAttribNames }: any) => {
		// if (modifiedAttribNames?.includes("description")) item.description = encode(item?.description?.truncate(20000,true));
		// if (modifiedAttribNames?.includes("name")) item.name = encode(item?.name?.truncate(100,true));
		upsertValueLibrary({ libraryId, libraryValue: item });
	};

	return (
		<SideModal show={isOpen} onHide={onClose} scroll backdrop placement="end" container={document.getElementById("modal-root")}>
			{itemId ? (
				<div>
					<ItemProvider initialAction={currentItem} updateService={handleUpdateLibraryItem}>
						<Content {...props} />
					</ItemProvider>
				</div>
			) : null}
		</SideModal>
	);
}

const Content = (props: Props) => {
	const { onClose, libraryId, customItemsIds, stageId } = props;
	const { currentItem, setCurrentItem, handleChange } = useItem();
	const isReadOnly = useSelector(({ auth }: any) => auth.userInfo.UserType)?.isReadOnly();
	const [isRelationLoading, setIsRelationLoading] = useState(true);

	useEffect(() => {
		getCustomLibraryLinkedRecordsFn({
			libraryId,
			libraryValueId: currentItem?.id,
			onSuccess: (data) => {
				setIsRelationLoading(false);
				setCurrentItem(data);
			},
		});
	}, [currentItem?.id]);

	const { navigationList, updateCurrentItem } = useNavigationListData({ allItemsSelector: getAllCustomLibraryItems(libraryId), selectedItemsIds: customItemsIds });
	const disabled = isReadOnly || !currentItem?.isCustom;

	return (
		<>
			<Header
				onClose={onClose}
				navigationList={navigationList as string[]}
				currentItemId={currentItem.id}
				setCurrentItem={updateCurrentItem}
				actions={BaseActions({ libraryId, item: currentItem, handleChange, onClose })}
				showCopyUrl={false}
				disabled={disabled}
			/>
			<HeaderTitle icon="bookmark" labelPlaceholder="NEW_LIBRARY" renderCustomIcon={() => <ColorCircle color={currentItem?.colorCode} />} disabled={disabled} />
			<>
				{isRelationLoading ? <Spinner isFixed={false}/> : <Relations stageId={stageId} entityType={TypesTabs.CustomLibraries} defaultKey={1} onClose={onClose} disabled={disabled} />}
			</>
		</>
	);
};
